<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

import TrackersForm from './TrackersForm';
import { PageViewsTable } from 'coryallen-page-views'
import { CommunicationsTable } from 'coryallen-communications';

export default {
  page: {
    title: 'Trackers',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, TrackersForm, PageViewsTable, CommunicationsTable },
  data() {
    return {
      title: 'Trackers',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Trackers', to: '/trackers', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        getmapping: 'yes',
        wheres: {
          id: this.$route.params.id
        },
      },

      pageviews_loading: true,
      pageviews_filters: {
        paginate: 100,
        page: 1,
        total: 0,
        wheres: {
          tracker_id: ''
        }
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'coryallen\\Trackers\\Models\\Tracker',
      },

    }
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/trackers/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          if(!res.data.data[0].body) { res.data.data[0].body = ''; }
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.title;
          this.pageviews_filters.wheres.tracker_id = this.item.tracker_id;
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/trackers');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    update_tracker() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/trackers/update', this.item).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_tracker() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this tracker?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/trackers/delete/'+this.item.id, this.item).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.$router.push('/trackers');
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="pageviews_loading"></span> Page Views</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
    </b-tabs>

    <div v-if="item.id">

      <div class="row mt-4 set-sm-375">
        <div class="col-sm-4">

          <div class="card-box">
            <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> About :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><th class="border-0"><label>Website :</label></th><td class="border-0 small">{{item.website}}</td></tr>
                  <tr><th><label>Tracking ID :</label></th><td class="small">?id={{item.tracker_id}}</td></tr>
                  <tr><th><label>Description :</label></th><td class="small">{{item.description}}</td></tr>
                  <tr><th><label>View count :</label></th><td class="small">{{item.page_views_count}}</td></tr>
                  <tr><th><label>Updated on :</label></th><td class="small" v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td></tr>
                  <tr><th><label>Created on :</label></th><td class="small" v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
          <button type="button" class="btn btn-block btn-outline-danger" @click="delete_tracker" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete Tracker</button>

        </div>
        <div class="col-sm-8">

          <div v-show="tabIndex == 0">
            <div class="card-box p-0 position-relative">
              <transition name="fade">
                <div class="ribbon-two ribbon-two-primary" :key="1" v-if="pageviews_loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
              </transition>
              <div class="row p-3">
                <div class="col-lg-8">
                  <div class="form-inline">
                    <div class="form-group">
                      <select class="form-control" v-model="pageviews_filters.paginate">
                        <option value="100">Per page: (100)</option>
                        <option value="250">Per page: (250)</option>
                        <option value="500">Per page: (500)</option>
                        <option value="750">Per page: (750)</option>
                        <option value="1000">Per page: (1000)</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="text-lg-right mt-3 mt-lg-0">
                    <a @click="$refs['PageViewsTable'].fetchData()" class="btn btn-light waves-effect waves-light ml-1"><i class="remixicon-refresh-line"></i></a>
                  </div>
                </div>
              </div>
              <PageViewsTable v-if="pageviews_filters.wheres.tracker_id" ref="PageViewsTable" :filters="pageviews_filters" @loadchange="(e) => {pageviews_loading = e}"></PageViewsTable>
            </div>
          </div>

          <div v-show="tabIndex == 1">
            <div class="">
              <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
            </div>
          </div>

          <div v-show="tabIndex == 2">
            <div class="card-box">
              <b-form @submit.prevent="update_tracker">
                <TrackersForm :item="item"></TrackersForm>
                <div class="border-top border-light mt-5 pt-3 text-right">
                  <button type="submit" class="btn btn-success ml-3" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
                  <div class="clearfix"></div>
                </div>
              </b-form>
            </div>
          </div>

        </div>
      </div>

    </div>
  </Layout>
</template>
